import { z } from 'zod';

export const declarationViewGoodLVSchema = z.object({
  _id: z.string().optional().nullable(),
  referenceNumberUCR: z.string().optional().nullable(),
  additionalProcedure: z.array(z.string().optional().nullable()),
  descriptionOfGoods: z.string().optional().nullable(),
  commodityCode: z.object({
    hsCode: z.string().optional().nullable(),
  }),
  goodsMeasure: z.object({
    intrinsicValue: z.number().optional().nullable(),
    currencyCode: z.string().optional().nullable(),
    grossMass: z.number().optional().nullable(),
    supplementaryUnits: z.number().optional().nullable(),
  }),
  transportInsurance: z.object({
    currencyCode: z.string().regex(/^[A-Za-z]*$/, 'Only letters allowed'),
    amount: z.number().optional().nullable(),
  }),
  packaging: z.object({
    numberOfPackages: z.number().optional().nullable(),
  }),
  dutiesAndTaxes: z.object({
    methodOfPayment: z.string().optional().nullable(),
  }),
});

export type DeclarationViewGoodLVFormValues = z.infer<typeof declarationViewGoodLVSchema>;
